<app-admin-page-shell
  titleKey="app.admin.profile.title"
  subtitleKey="app.admin.profile.subtitle"
  [panelled]="false"
>
  <div class="admin-profile">
    <app-personal-data-editor
      [user]="admin()"
      [layout]="'admin'"
    />
  </div>
</app-admin-page-shell>
